import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/icons-material/esm/ArrowForward.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Button/Button.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Container/Container.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/material/esm/Grid/Grid.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Stack/Stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/utils/esm/useControlled/useControlled.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/utils/esm/useEnhancedEffect/useEnhancedEffect.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/utils/esm/useEventCallback/useEventCallback.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/utils/esm/useForkRef/useForkRef.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/utils/esm/useId/useId.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/utils/esm/useIsFocusVisible/useIsFocusVisible.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/utils/esm/useLazyRef/useLazyRef.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/utils/esm/useOnMount/useOnMount.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/utils/esm/usePreviousProps/usePreviousProps.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/utils/esm/useSlotProps/useSlotProps.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/utils/esm/useTimeout/useTimeout.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/buttons/SLButtonGroupAnrufenBuchen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLButtonGroupChatBuchen"] */ "/vercel/path0/src/components/buttons/SLButtonGroupChatBuchen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLBlogPreviewCard"] */ "/vercel/path0/src/components/cards/SLBlogPreviewCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLCard"] */ "/vercel/path0/src/components/cards/SLCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLCardTeamMember"] */ "/vercel/path0/src/components/cards/SLCardTeamMember.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLHomeTestimonialsCarousel"] */ "/vercel/path0/src/components/sections/home/SLHomeTestimonialsCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLSectionFaqs"] */ "/vercel/path0/src/components/sections/SLSectionFaqs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLHomePageTemplate"] */ "/vercel/path0/src/components/templates/home/SLHomePageTemplate.tsx");
